import { Box } from '@global-engineering-shared/gweb-material-ui';

import SearchOptionLabel from 'components/SearchBar/SearchOption/components/SearchOptionLabel';
import SearchOptionTitle from 'components/SearchBar/SearchOption/components/SearchOptionTitle';
import useStyles from 'components/SearchBar/SearchOption/SearchOption.styles';
import { IFormattedSearch } from 'components/SearchBar/SearchOption/types/IFormattedSearch';
import { searchOptionLabelElements } from 'components/SearchBar/SearchOption/utils/searchOptionLabelElements';

type SearchOptionProps = {
  option: IFormattedSearch;
  inputValue: string;
};

const SearchOption = ({ option, inputValue }: SearchOptionProps) => {
  const classes = useStyles();
  const elements = searchOptionLabelElements(option);

  return (
    <Box className={classes.root}>
      <SearchOptionTitle option={option} inputValue={inputValue} />
      <SearchOptionLabel elements={elements} inputValue={inputValue} />
    </Box>
  );
};

export default SearchOption;
